
export default {
  name: 'ImageRoll',
  props: {
    blok: {
      type: Object,
      required: true
    }
  }
}
